// extracted by mini-css-extract-plugin
module.exports = {"container":"other-offers-link_container__31chu","link":"other-offers-link_link__2AWps","price":"other-offers-link_price__3twfr"};